export default "__VITE_ASSET__DD7je98N__"